import React from "react";
import FAQItem from "../components/faqItem/FaqItem";
import { Col, Row } from "reactstrap";

const FAQ = () => {
  const faqs = [
    {
      question: "What is Minimalist?",
      answer: "You can read more about us in the About section.",
    },
    {
      question: "Are your products safe to use?",
      answer:
        "All our products undergo a thorough safety assessment before hitting the market. Each product is Dermatologist Tested for safety as per BIS guidelines in an independent third party lab. Each formulation is approved by respective Drug Authority. Once manufactured, our products pass a 12 point quality check in a government approved laboratory. Only then the product reaches to you. For best results, we recommend always following the directions of use. If you have questions about any ingredient we use, please reach out to us via our contact page and our lab will provide a response.",
    },
    {
      question: "Where do you ship to?",
      answer:
        "We are currently shipping to India only. Please watch out this space for information on international shipping. Across India, we ship to over 16,000 pincodes and offer Prepaid or Cash on Delivery services, both.",
    },
    {
      question: "How long will my order take?",
      answer:
        "We usually ship within 24 working hours after receiving an order. Once shipped, our logistics partner can take anywhere from 2 to 5 days to get the order delivered to you. Users in metro cities can expect a faster delivery speed (within 3 days).",
    },
    {
      question: "What is your return policy?",
      answer:
        "You can raise a return request to us by dropping us an email at help@beminimalist.co and our team will assist you. Return shipments are also managed by us. For more details, please check our return & refund policies page.",
    },
  ];

  return (
    <Row className="pages_wrap_genric">
      <Col md="10">
        <h1 className="faq_heading">Questions</h1>
        {faqs.map((faq, index) => (
          <FAQItem
            key={index}
            index={index}
            question={faq.question}
            answer={faq.answer}
          />
        ))}
      </Col>
    </Row>
  );
};

export default FAQ;
